import { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Cpu,
  Activity,
  Server,
  HardDrive,
  RefreshCw
} from 'lucide-react';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const EcosystemModule = ({ token }) => {
  const [agents, setAgents] = useState([]);
  const [status, setStatus] = useState({
    vps_ip: 'Matrix Core',
    vps_status: 'online',
    avg_cpu: 0,
    avg_memory: 0,
    online: 0,
    standby: 0,
    offline: 0,
    total_agents: 0
  });
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const fetchData = async () => {
    try {
      const res = await axios.get(`${API}/agents`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {}
      });

      const rawAgents = Array.isArray(res.data?.agents)
        ? res.data.agents
        : Array.isArray(res.data)
        ? res.data
        : [];

      const normalizedAgents = rawAgents.map((agent, index) => ({
        id: agent.id || agent.name || index,
        name: agent.name || 'unknown-agent',
        codename: agent.codename || agent.name || `agent-${index + 1}`,
        role: agent.role || 'undefined-role',
        status: agent.status || 'offline',
        port: agent.port || '-',
        cpu_usage: agent.cpu_usage ?? 0,
        memory_usage: agent.memory_usage ?? 0
      }));

      const online = normalizedAgents.filter(a => a.status === 'online').length;
      const standby = normalizedAgents.filter(a => a.status === 'standby').length;
      const offline = normalizedAgents.filter(a => a.status !== 'online' && a.status !== 'standby').length;

      setAgents(normalizedAgents);
      setStatus({
        vps_ip: 'Matrix Core',
        vps_status: 'online',
        avg_cpu: 0,
        avg_memory: 0,
        online,
        standby,
        offline,
        total_agents: normalizedAgents.length
      });
    } catch (error) {
      console.error('Failed to fetch ecosystem data:', error);
      toast.error('Erreur chargement écosystème');
      setAgents([]);
      setStatus({
        vps_ip: 'Matrix Core',
        vps_status: 'offline',
        avg_cpu: 0,
        avg_memory: 0,
        online: 0,
        standby: 0,
        offline: 0,
        total_agents: 0
      });
    } finally {
      setLoading(false);
    }
  };

  const refreshData = async () => {
    setRefreshing(true);
    await fetchData();
    setRefreshing(false);
    toast.success('Données actualisées');
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-[#DC143C] font-mono text-sm animate-pulse">
          CHARGEMENT DE L'ÉCOSYSTÈME...
        </div>
      </div>
    );
  };

  const getStatusColor = (s) => {
    switch (s) {
      case 'online': return '#00FF9D';
      case 'standby': return '#FFD700';
      case 'offline': return '#444444';
      default: return '#444444';
    }
  };

  return (
    <div className="p-4 text-white">
      <h2 className="text-lg mb-4">DNCM Ecosystem</h2>

      <button onClick={refreshData} className="mb-4">Refresh</button>

      <div className="grid gap-3">
        {agents.map((agent, index) => (
          <div key={index} style={{ borderLeft: `3px solid ${getStatusColor(agent.status)}`, padding: "10px", background: "#111" }}>
            <div><strong>{agent.name}</strong></div>
            <div>{agent.role}</div>
            <div>Status: {agent.status}</div>
            <div>Port: {agent.port}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EcosystemModule;
